import { useMemo } from "react";

import { useAuth } from "@/hooks/useAuth";
import { can } from "@/lib/permissions";
import type { Permission } from "@/types";

export function usePermissions(): { can: (permission: Permission) => boolean } {
  const { user } = useAuth();
  return {
    can: useMemo(() => (permission: Permission) => can(user, permission), [user]),
  };
}
